module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M23.26.804C21.46-.744 20 .012 20 2.496V8H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18v5.504c0 2.484 1.464 3.248 3.268 1.688L39.26 17.408c.908-.776.912-2.036.004-2.812L23.26.804z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/forward-1.js
// module id = 1156
// module chunks = 14